/**
 * @generated SignedSource<<dde95efff3a98bb030a2da634d4a3603>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReprocessPageMutation$variables = {};
export type ReprocessPageMutation$data = {
  readonly ReprocessCapabilities: {
    readonly error: string | null;
    readonly summary: {
      readonly capabilitiesRemoved: number;
      readonly capabilitiesUpserted: number;
      readonly featureFlagsCreated: number;
      readonly featureFlagsExisting: number;
      readonly planCapabilitiesUpserted: number;
    };
  };
};
export type ReprocessPageMutation = {
  response: ReprocessPageMutation$data;
  variables: ReprocessPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReprocessCapabilitiesPayload",
    "kind": "LinkedField",
    "name": "ReprocessCapabilities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReprocessCapabilitiesSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagsCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagsExisting",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capabilitiesUpserted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capabilitiesRemoved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planCapabilitiesUpserted",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReprocessPageMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReprocessPageMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "027256d4641c73aa6c602850eaa0cb3b",
    "id": null,
    "metadata": {},
    "name": "ReprocessPageMutation",
    "operationKind": "mutation",
    "text": "mutation ReprocessPageMutation {\n  ReprocessCapabilities {\n    summary {\n      featureFlagsCreated\n      featureFlagsExisting\n      capabilitiesUpserted\n      capabilitiesRemoved\n      planCapabilitiesUpserted\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "12b45ea9c3787b2d3d3f66bde767ba3f";

export default node;
